import * as fromDatatype from "../../../../models/datatype-library";

export class OcrGenericDocumentSearchDTO {
  guids?: any[];
  ocr_scanned_doc_hdr_guid?: string;
  ocr_branch_hdr_guid?: string;
  ocr_company_hdr_guid?: string;
  txn_type?: string;
  txn_code?: string;
  res_ocr_branch_hdr_guid?: string;
  res_ocr_company_hdr_guid?: string;
  server_doc_1?: string;
  server_doc_type?: string;
  client_doc_type?: string;
  algorithm_provider?: string;
  login_subject_guid?: string;
  entity_hdr_guid?: string;
  membership_hdr_guid?: string;
  website_hdr_guid?: string;
  created_date?: fromDatatype.TimestampTzDatatypeInterface;
  created_date_to?: fromDatatype.TimestampTzDatatypeInterface;
  created_date_from?: fromDatatype.TimestampTzDatatypeInterface;
  updated_date?: fromDatatype.TimestampTzDatatypeInterface;
  posting_status?: string;
  created_by_subject_guid?: string;
  updated_by_subject_guid?: string;
  line_ocr_item_hdr_guid?: string;
  line_fi_item_hdr_guid?: string;
  line_res_ocr_item_hdr_guid?: string;
  line_res_fi_item_hdr_guid?: string;
  line_ocr_scanned_doc_line_guid?: string;
  ocr_scanned_doc_hdr_guids?: any[];
  created_by_subject_guids?: any[];
  calcTotalRecords?: boolean;
  snapshot?: string;
  vrsn?: string;
  orderBy?: string;
  order?: string;
  limit?: number;
  status?: string;
  search_word?: string;
  updated_date_from?: fromDatatype.TimestampTzDatatypeInterface;
  updated_date_to?: fromDatatype.TimestampTzDatatypeInterface;
  scanned_doc_process_status?: string;
  verification_status?: string;
}
